export const ListItemSkeleton = () => (
  <div className="rounded items-center justify-center w-full animate-pulse">
    <div className="bg-slate-700 h-10 w-full rounded-lg" />
  </div>
);
